import { makeStyles } from '@material-ui/core/styles'
import { useHistory } from 'react-router-dom'
import { useEffect } from 'react'
import { useQuery } from '@apollo/client'
import { useSelector } from 'react-redux'
import GraphQlErrors from 'src/components/common/GraphQlErrors'
import { getClientId } from 'src/utils/commonMethods'
import { FETCH_ALL_CD_ACCOUNTS_FOR_CLIENTS } from 'src/services/individualService'
import LoadingModal from 'src/components/common/LoadingModal'
import formatToINR from 'src/utils/commonMethods/formatToINR'

const CdBalance = ({ clientId }) => {
  const classes = useStyles()
  const history = useHistory()
  const userInfo = useSelector((state) => state?.userInfo)
  const requestClientId = getClientId(clientId, userInfo)

  const {
    loading: cdAccountForClientsLoading,
    error: cdAccountForClientsError,
    data: cdAccountForClientsData,
    refetch,
  } = useQuery(FETCH_ALL_CD_ACCOUNTS_FOR_CLIENTS(requestClientId), {
    errorPolicy: 'all',
    fetchPolicy: 'cache-and-network',
  })

  useEffect(() => {
    refetch()
  }, [requestClientId, refetch])

  if (cdAccountForClientsError) {
    return <GraphQlErrors error={cdAccountForClientsError} />
  }

  const cdBalanceViewNavigation = () => {
    history.push('/individual/dashboard/cdBalanceView/')
  }

  const cdAccountData =
    cdAccountForClientsData?.fetchAllCdAccountsForClient?.data

  return (
    <>
      <LoadingModal loading={cdAccountForClientsLoading} />
      <div className={classes.rootContainer}>
        <div className={classes.root} onClick={cdBalanceViewNavigation}>
          <div className={classes.textContainer}>
            <span className={classes.text}> CD Balance</span>
            <br></br>
            {cdAccountData?.cdAccountsDetails?.length > 0 ? (
              <span className={classes.balanceText}>
                {formatToINR(
                  cdAccountData?.cdAccountsDetails?.[0]?.currentCdAccountBalance
                )}
                &nbsp;Deducted
              </span>
            ) : (
              <span className={classes.balanceText}>No Data</span>
            )}
          </div>
        </div>
      </div>
    </>
  )
}

export default CdBalance
const useStyles = makeStyles({
  rootContainer: {
    padding: '20px 13px 20px 0px',
  },
  root: {
    backgroundColor: '#FFFFFF',
    width: '100%',
    height: '100px',
    overflowX: 'hidden',
    position: 'relative',
    borderRadius: '10px',
    border: '1px solid rgba(0,0,0,.125)',
    boxShadow: '4px 7px 15px rgba(0, 0, 0, 0.1)',
    textAlign: 'center',
    cursor: 'pointer',
  },
  textContainer: {
    padding: '26px',
  },
  text: {
    fontSize: '18px',
    fontWeight: '400',
    fontFamily: 'Roboto',
    lineHeight: '21px',
    color: '#B92250',
    textAlign: 'center',
  },
  balanceText: {
    fontSize: '12px',
    fontFamily: 'Roboto',
    lineHeight: '14px',
    fontWeight: '400',
  },
})
